import * as React from "react";
import {isEmpty as _isEmpty} from "lodash";
import {ModalComponent} from "../components/ModalComponent";
import {ErrorContainerProps} from "./ErrorContainer";

export interface ConfirmModalContainerProps {
    errorText: string,
    errorDetails?: string,
    okButtonText?: string,
    okCallBack?: (evt: any) => void,
    cancelCallBack?: () => void,
    keepPadding?: boolean,
    showGlyphicon?: boolean,
    showErrorDetails?: boolean
}

export interface ConfirmModalContainerState {
    errorDetailsVisibility?: boolean;
}

class ConfirmModalContainer extends React.Component<ConfirmModalContainerProps, ConfirmModalContainerState> {
    constructor(props: ErrorContainerProps) {
        super(props);
        this.state = {
            errorDetailsVisibility: false
        }
    }

    toggleErrorDetails = () => {
        this.setState({
            errorDetailsVisibility: true
        })
    }
    render() {
        let errorText = this.props.errorText;
        let errorDetails = this.props.errorDetails;
        let padding = this.props.keepPadding !== undefined ? this.props.keepPadding : true;
        let okButtonText = this.props.okButtonText !== undefined ? this.props.okButtonText : "Ok";
        return (
            <ModalComponent modalSize={"x-small"} keepPadding={padding}>
                <div className={"error-top-container animated slideInDown"}>
                    <div className={"error-header"}>
                        {this.props.showGlyphicon && <span className={"glyphicon glyphicon-exclamation-sign"} />}
                    </div>
                    <div className={"error-text"}>{errorText}</div>
                    {
                        !_isEmpty(errorDetails) &&
                        <div className={"error-details"}>
                            {
                                !this.props.showErrorDetails && !this.state.errorDetailsVisibility &&
                                <div className={`error-details-label`} onClick={this.toggleErrorDetails}>Error details</div>
                            }
                            {
                                (this.props.showErrorDetails || this.state.errorDetailsVisibility) &&
                                <div className={`error-details-content animated fadeIn`}>{errorDetails}</div>
                            }
                        </div>
                    }
                    <div className={"close-error-message"}>
                        <div className={"button cancel-button"} onClick={this.props.cancelCallBack}>Cancel</div>
                        <div className={"button ok-button"} onClick={(evt) => this.props.okCallBack(evt)}>{okButtonText}</div>
                    </div>
                </div>
            </ModalComponent>
        )
    }
}

export default ConfirmModalContainer;